import { inject, provideAppInitializer } from '@angular/core'
import { firstValueFrom, of } from 'rxjs'
import { catchError } from 'rxjs/operators'

import { FeatureFlagService } from '../services/feature-flag.service'
import { FeatureFlag } from '../types/feature-flag.type'
import { ApiResponse } from '../types/response.type'

function initializeFeatureFlag(): () => Promise<ApiResponse<FeatureFlag[]> | null> {
	const featureFlagService = inject(FeatureFlagService)

	return () => {
		return firstValueFrom(
			featureFlagService.fetchFeatureFlags().pipe(
				catchError((error) => {
					console.error('Error fetching feature flags:', error)
					return of(null)
				}),
			),
		)
	}
}

export const provideFeatureFlag = () =>
	provideAppInitializer(() => {
		const initializerFn = initializeFeatureFlag()
		return initializerFn()
	})
